import 'reflect-metadata';
import WpBaseComponent from './wp-base-component';

import { vuetifyComponents } from './vuetify-components';

export default WpBaseComponent;

import WpNotificationQueue from './WpNotification/wp-notification-queue';
import WpTelegramForm from './WpTelegramForm/wp-telegram-form';
import WpByOrderInfo from './WpByOrderInfo/wp-by-order-info';
import WpRefundByOrderInfo from './WpRefundByOrderInfo/wp-refund-by-order-info';
import WpHdOrder from './WpHdOrder/wp-hd-order';
import WpTicketBarcode from './WpTicketBarcode/wp-ticket-barcodes';
import HDAdmin from './HdAdmin/hd-admin';

export { WpNotificationQueue }
export { WpTelegramForm }
export { WpByOrderInfo }
export { WpRefundByOrderInfo }
export { WpHdOrder }
export { HDAdmin }

const wpComponents = {
    'wp-notification': WpNotificationQueue,
    'wp-telegram-form': WpTelegramForm,
    'wp-by-order-info': WpByOrderInfo,
    'wp-refund-by-order-info': WpRefundByOrderInfo,
    'wp-hd-order': WpHdOrder,
    'wp-ticket-barcodes': WpTicketBarcode,
    "hd-admin": HDAdmin
}

const extend = function <First, Second>(first: First, second: Second): First & Second {
    const result: Partial<First & Second> = {};
    for (const prop in first) {
        if (Object.prototype.hasOwnProperty.call(first, prop)) {
            (result as First)[prop] = first[prop];
        }
    }
    for (const prop in second) {
        if (Object.prototype.hasOwnProperty.call(second, prop)) {
            (result as Second)[prop] = second[prop];
        }
    }
    return result as First & Second;
}

export { extend, wpComponents, vuetifyComponents };